import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import ContactListItem from "./ContactListItem";
import { Box, Stack, Typography, styled } from "@mui/material";

const ContactDetailsContainer = styled(Box)({
	minHeight: "20rem",
	width: "100%",
});

const NoContactSelected = () => {
	return (
		<ContactDetailsContainer className="cstm-height h-[23rem]">
			<Stack
				flexDirection="column"
				alignItems="center"
				gap={1}
				justifyContent="center"
			>
				<img src="/img/no-contacts-illustration.svg" height="75%" />
				<Typography
					variant="body1"
					sx={{
						fontWeight: "600",
						color: "#15194B",
						fontFamily: "Figtree-Regular",
					}}
				>
					Wohoo! All Caught Up
				</Typography>
				<Typography
					sx={{
						fontWeight: "700",
						color: "#8387BD",
						fontFamily: "Figtree-Regular",
						fontSize: "13px",
					}}
				>
					No pending request from other users
				</Typography>
			</Stack>
		</ContactDetailsContainer>
	);
};

function ContactsList(props) {
	const { contactsDataList, selectedTabId, ignore, accept } = props;

	if (contactsDataList.length === 0) return <NoContactSelected />;

	return (
		<Scrollbars autoHide style={{ height: `23rem` }}>
			{contactsDataList.length > 0 &&
				contactsDataList.map((contact, index) => {
					return (
						<ContactListItem
							contactData={contact}
							selectedTabId={selectedTabId}
							ignore={ignore}
							accept={accept}
                            allProfileImages={props.allProfileImages}
						/>
					);
				})}
		</Scrollbars>
	);
}

export default React.memo(ContactsList);
